/*
* Pipeline Theme — custom JavaScript
*
* This file is imported from layout/theme.liquid. Pipeline ships that import
* COMMENTED OUT, so if zoom (or anything else here) stops working, check there
* first — see the [ATLAS] note next to the <script> tag.
*
* Everything must stay inside the IIFE below so nothing leaks into global scope.
* NOTE: each IIFE needs its OWN closing "})();". A missing one is a SyntaxError
* that silently kills this entire file — no console warning on the page, just
* nothing running.
*/

(function () {
  // ==========================================================================
  // [ATLAS] Make the whole product image clickable to open the PhotoSwipe zoom
  // --------------------------------------------------------------------------
  // Pipeline only opens the lightbox from a small button inside
  // .media__buttons__holder. Customers expect clicking the image itself to
  // zoom, so this forwards a click anywhere on the image to that button.
  // ==========================================================================
  function initImageClickZoom() {
    var wrappers = document.querySelectorAll('.product-image-wrapper:not([data-atlas-zoom])');
    wrappers.forEach(function (wrapper) {
      wrapper.setAttribute('data-atlas-zoom', '1'); // [ATLAS] bind once per wrapper
      wrapper.style.cursor = 'zoom-in';
      wrapper.addEventListener('click', function (e) {
        // [ATLAS] the real zoom button is inside the image — don't double-fire
        if (e.target.closest('.media__buttons__holder')) return;
        // [ATLAS] scope the lookup to THIS slide, not the whole document, or a
        // gallery with several images always opens the first one
        var cell = wrapper.closest('.flickity-cell, .product__media, li');
        var zoomBtn = cell
          ? cell.querySelector('.media__buttons__holder button')
          : wrapper.querySelector('.media__buttons__holder button');
        if (zoomBtn) zoomBtn.click();
      });
    });
  }

  // [ATLAS] Flickity builds the gallery asynchronously, so slides can appear
  // after first paint. Watch for them rather than binding once.
  var zoomObserver = new MutationObserver(function () {
    if (document.querySelector('.product-image-wrapper')) {
      initImageClickZoom();
    }
  });
  zoomObserver.observe(document.body, { childList: true, subtree: true });

  // [ATLAS] This file loads with defer, so DOMContentLoaded normally still
  // fires after it — but guard anyway in case the import is ever moved.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageClickZoom);
  } else {
    initImageClickZoom();
  }

  // [ATLAS] Switching variants swaps the gallery markup
  document.addEventListener('theme:variant:change', function () {
    setTimeout(initImageClickZoom, 300);
  });
})();

(function () {
  // ==========================================================================
  // [ATLAS] Fix #hash anchor links landing at the top of the page — Aug 2026
  // --------------------------------------------------------------------------
  // Links like /pages/faq#price-guarantee and /pages/faq#study-sets are meant
  // to jump straight to that FAQ question. The browser's native #hash jump
  // does fire on load, but this theme's entrance/reveal animation resets
  // scroll position back to the top at an unpredictable point during load
  // (confirmed via testing — a single re-scroll attempt sometimes gets
  // overwritten by that reset). Re-assert the scroll several times over the
  // first few seconds so the last attempt — after the theme's own reset has
  // already happened — is the one that sticks. Early attempts are instant so
  // we're roughly in place fast; later corrections use smooth scrolling so a
  // late correction never reads as a jarring snap to someone already reading.
  // ==========================================================================
  function scrollToHashTarget(behavior) {
    if (!window.location.hash) return;
    var id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch (e) {
      id = window.location.hash.slice(1);
    }
    var target = document.getElementById(id);
    if (!target) return;

    // [ATLAS] Only subtract the header's height if it's actually overlaying
    // content right now (fixed/sticky). In normal flow it isn't, so no offset
    // is needed there.
    var header = document.querySelector('.theme__header');
    var headerOffset = 0;
    if (header) {
      var headerPosition = getComputedStyle(header).position;
      if (headerPosition === 'fixed' || headerPosition === 'sticky') {
        headerOffset = header.getBoundingClientRect().height;
      }
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 24;
    window.scrollTo({ top: top < 0 ? 0 : top, left: 0, behavior: behavior || 'instant' });
  }

  function scheduleHashScrollRetries() {
    // [ATLAS] Re-assert at several points across ~3s. Whichever attempt lands
    // after the theme's reset wins and stays put; earlier ones are harmless
    // even if immediately overwritten.
    var attempts = [
      { delay: 50, behavior: 'instant' },
      { delay: 300, behavior: 'instant' },
      { delay: 600, behavior: 'smooth' },
      { delay: 1000, behavior: 'smooth' },
      { delay: 1500, behavior: 'smooth' },
      { delay: 2200, behavior: 'smooth' },
      { delay: 3000, behavior: 'smooth' }
    ];
    attempts.forEach(function (attempt) {
      setTimeout(function () {
        scrollToHashTarget(attempt.behavior);
      }, attempt.delay);
    });
  }

  window.addEventListener('load', scheduleHashScrollRetries);

  // [ATLAS] Also handle clicking an in-page anchor link without a full
  // navigation (e.g. clicking the same FAQ link twice).
  window.addEventListener('hashchange', function () {
    setTimeout(function () {
      scrollToHashTarget('smooth');
    }, 50);
  });
})();

(function () {
  // ==========================================================================
  // [ATLAS V7 8/31] Every add to cart -> straight to CHECKOUT
  // --------------------------------------------------------------------------
  // A house plan is a one-item considered purchase - nobody adds a second
  // plan - so leaving the customer where they were, at the moment of highest
  // intent, is a dead end.
  //
  // THE CART PAGE IS NOT REMOVED. /cart still renders normally, the header
  // cart icon still links to it, and Update Cart / Check Out / Remove all
  // still work there. It is simply no longer the automatic destination of an
  // add. That page is still the only place to REMOVE the Readable Reverse
  // add-on, so it has to keep working.
  //
  // SCOPE - widened 8/31 from PDP-only to every add-to-cart on the site.
  // Shopify gives this theme THREE different add paths and they behave
  // differently, which is why there are three branches below:
  //
  //   1 - BUTTON CLICK inside a form[action="/cart/add"].
  //       This is the one that matters most. Verified on a collection grid:
  //       the quick-add button fires a click and NO submit event at all - the
  //       theme's Alpine handler calls preventDefault and does its own AJAX
  //       add. A submit-only interceptor never sees it, which is why the
  //       earlier version of this file left collection grids on the page.
  //
  //   2 - FORM SUBMIT backstop, for a real submit (Enter key in a field, or
  //       any add path that does not go through a click).
  //
  //   3 - LINK, because the Study Set button is an <a href="/cart/add?id=...">,
  //       not a form. Shopify answers that GET by adding the item and
  //       redirecting to /cart, so without this branch it is the one add that
  //       still dead-ends.
  //
  // Values are read with FormData rather than querySelector so radio-style
  // variant pickers, quantity and line-item properties all survive.
  //
  // Readable Reverse rides along inside the SAME /cart/add.js call, so the
  // redirect can never fire before the whole line-item group is added. A
  // separate add plus a separate redirect would race, and someone who ticked
  // Readable Reverse could land at checkout without it.
  //
  // TO NARROW THIS BACK to the product page only: add
  //   if (!form.matches('form[data-product-form]')) return;
  // at the top of handleFormAdd(). That attribute is on exactly one form per
  // PDP and on nothing else.
  // ==========================================================================

  var CHECKOUT_URL = '/checkout';

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  function goToCheckout() {
    window.location.href = CHECKOUT_URL;
  }

  // [ATLAS] Build the line item from whatever the form actually contains.
  function itemFromForm(form) {
    var item = { quantity: 1 };
    var props = {};
    var hasProps = false;
    new FormData(form).forEach(function (value, key) {
      if (key === 'id') item.id = parseInt(value, 10);
      else if (key === 'quantity') item.quantity = parseInt(value, 10) || 1;
      else if (key === 'selling_plan' && value) item.selling_plan = value;
      else if (key.indexOf('properties[') === 0) {
        props[key.slice(11, -1)] = value;
        hasProps = true;
      }
    });
    if (!item.id) return null;
    if (hasProps) item.properties = props;
    return item;
  }

  function handleFormAdd(e, form, trigger) {
    // [ATLAS] A failed AJAX add re-submits the form so the theme can show its
    // own error. This flag lets that second pass through untouched - without
    // it the handler would catch its own retry and loop.
    if (form.getAttribute('data-atlas-fallback')) {
      form.removeAttribute('data-atlas-fallback');
      return;
    }

    var item = itemFromForm(form);
    if (!item) return; // [ATLAS] nothing selected - let the theme handle it

    var box = form.querySelector('[data-readable-reverse-checkbox]');
    var wantsRR = !!(box && box.checked);
    var rrId = wantsRR ? parseInt(box.getAttribute('data-rr-variant-id'), 10) : null;
    if (wantsRR && !rrId) return; // [ATLAS] RR ticked but no variant id - don't silently drop it

    var items = [item];
    if (wantsRR) items.push({ id: rrId, quantity: 1 });

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var btn = trigger || form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('loading');

    addItems(items)
      .then(goToCheckout)
      .catch(function (err) {
        console.error('[ATLAS] add-to-cart failed - falling back to the theme handler', err);
        if (btn) btn.classList.remove('loading');
        if (box) box.checked = false;
        form.setAttribute('data-atlas-fallback', '1');
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
  }

  function handleLinkAdd(e, link) {
    var href = link.getAttribute('href') || '';
    var params = new URLSearchParams(href.split('?')[1] || '');
    var id = parseInt(params.get('id'), 10);
    if (!id) return; // [ATLAS] no variant in the link - let the browser follow it

    var qty = parseInt(params.get('quantity'), 10) || 1;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    link.classList.add('loading');

    addItems([{ id: id, quantity: qty }])
      .then(goToCheckout)
      .catch(function (err) {
        console.error('[ATLAS] add-to-cart link failed - following the plain link instead', err);
        link.classList.remove('loading');
        window.location.href = href; // [ATLAS] Shopify adds it and lands on /cart
      });
  }

  function cartAddFormFor(el) {
    var form = el && el.closest ? el.closest('form') : null;
    if (!form) return null;
    return (form.getAttribute('action') || '').indexOf('/cart/add') > -1 ? form : null;
  }

  // --- 1 and 3 - CLICK: add buttons, and the Study Set link ------------------
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // [ATLAS] open-in-new-tab etc.
    if (!e.target || !e.target.closest) return;

    var link = e.target.closest('a[href*="/cart/add"]');
    if (link) {
      handleLinkAdd(e, link);
      return;
    }

    var btn = e.target.closest('button, input[type="submit"]');
    if (!btn) return;
    // [ATLAS V8 9/16] Only a SUBMIT button adds to cart. The My List heart on the
    // plan page is a type="button" that sits inside the same product form, and
    // without this line a click on the heart added the plan and went to checkout.
    // A <button> with no type attribute is a submit button, so that still adds.
    if (btn.tagName === 'BUTTON' && (btn.getAttribute('type') || 'submit').toLowerCase() !== 'submit') return;
    var form = cartAddFormFor(btn);
    if (!form) return;
    handleFormAdd(e, form, btn);
  }, true); // capture phase - runs before the theme's own Alpine handler

  // --- 2 - SUBMIT backstop (Enter key, or any non-click submit) --------------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    handleFormAdd(e, form, null);
  }, true); // capture phase
})();

/* ==========================================================================
 * [ATLAS] "MY LIST" — save-for-later hearts + email capture
 * Built Sep 2026 · append to the END of assets/custom.js
 * --------------------------------------------------------------------------
 * WHAT IT DOES
 *   · Puts a heart on every product card (top-LEFT — top-right is the
 *     "SAVE $xxx" badge) and beside Add to Cart on every plan page.
 *   · Saves to localStorage. No account, no email, works instantly, persists
 *     across sessions on that device.
 *   · Slide-out drawer lists everything saved, reachable from the header
 *     heart, the toast, or the #my-list hash on any URL.
 *   · After the FIRST save it opens the drawer once, where the email capture
 *     lives: "we'll email your list so you can pick up on any device."
 *   · Email posts to Shopify's native customer form — the exact same endpoint
 *     as the footer newsletter — so subscribers land in Customers with
 *     marketing consent, tagged `my-list` + `plan-<handle>` for each save.
 *   · Fires GA4: add_to_wishlist / remove_from_wishlist / view_wishlist /
 *     generate_lead.
 *
 * NOTHING ELSE IN THE THEME IS TOUCHED. This is the only file that changes.
 *
 * TUNING — everything worth changing is in CFG, ~30 lines down.
 * ========================================================================== */

(function () {
  'use strict';

  // ==========================================================================
  // CONFIG
  // ==========================================================================
  var CFG = {
    // Wording. Change these three and the whole feature renames itself.
    NAME:        'My List',
    PDP_LABEL:   'Add to My List',
    PDP_SAVED:   'Saved',

    // 'inline'  = heart sits to the RIGHT of Add to Cart, same row  (current)
    // 'stacked' = full-width labelled button on its own row under Add to Cart
    //
    // MEASURED on the live PDP at three window widths — do not guess these.
    // "Add to Cart • $1,549.80" needs 233px (185px of text + 48px padding),
    // and the buy column is NOT a fixed fraction of the viewport:
    //     viewport 1470 -> column 414px      viewport 1024 -> column 421px
    //     viewport  768 -> column 326px  <-- the tablet squeeze
    // So the heart's label can only ride alongside Add to Cart on real
    // desktops, and the three states below are set from those numbers:
    //   icon-only 54px -> Add to Cart keeps 262-357px  ✓ one line everywhere
    //   heart + label  -> depends entirely on how long the label is
    //
    // ⚠️ Sep 6: a labelled heart WAS enabled above 1025px, budgeted against the
    // string "My List" (126px). The label actually rendered is PDP_LABEL,
    // "Add to My List" — 185px — which left Add to Cart 219px against the 233px
    // it needs, and it wrapped to two lines on the live site. The label-reveal
    // rule is gone. If you ever want words back in the row, measure THE STRING
    // YOU ARE ACTUALLY SHIPPING with an off-screen <span>, not a shorter stand-in.
    //
    // So: icon-only beside Add to Cart at 600px and up; below that the row
    // unstacks and the heart gets a full-width button where the label fits.
    PDP_LAYOUT:  'inline',
    PDP_STACK_BELOW: 600,

    ACCENT:      '#A31F34',  // the crimson already used by Add to Cart
    INK:         '#222222',
    MAX_ITEMS:   60,

    // Open the drawer automatically the very first time someone saves,
    // so they discover the list + see the email offer. Once per browser.
    OPEN_ON_FIRST_SAVE: true,

    // ---- The customer-facing promise ---------------------------------------
    // DELIBERATELY NOT a price-drop alert — that teaches people to wait for a
    // sale on a product whose base price is contractually fixed. The promise is
    // "we'll send you your list", which is fulfilled BY HAND from a template:
    // read the tags on the customer record, paste the ?list= link, send.
    // That makes it a promise with a person behind it — if the send doesn't
    // happen within a day or so, change this wording rather than let it rot.
    ASK_HEAD:    'Want your list emailed to you?',
    ASK_BODY:    'Your plans are saved in this browser. Add your email and ' +
                 'we’ll send your list over so you can open it anywhere.',
    ASK_FINE:    'We’ll email you your saved plans, plus the occasional ' +
                 'new-plan announcement. Unsubscribe any time.',
    ASK_DONE:    'We’ll send your saved plans over shortly.',
    // Shopify Forms ships its button as "Submit". Relabelled here rather than in
    // the Forms builder so every word the customer reads lives in this one block.
    // Done with a CSS ::after rather than by rewriting the button's contents —
    // the app owns that DOM and puts its loading state inside it.
    SEND_LABEL:  'Send',

    // ---- The Shopify Form ---------------------------------------------------
    // Everything about the email capture hangs off this id: the Form ID from
    // the Forms app. It appears in the DOM as
    //   <div data-forms-id="forms-root-1142708">  inside a .shopify-app-block
    // placed in the Footer section group, so it exists on every page. Fields
    // live one level down inside a <shopify-forms-embed> SHADOW ROOT —
    // document.getElementById cannot see them. All verified live Sep 6 2026.
    FORM_ID:     '1142708',

    // ---- What lands on the Shopify customer record --------------------------
    // Three kinds of tag, so the record answers three different questions:
    //   my-list          -> the segment to broadcast to
    //   from-<handle>    -> THE PLAN THEY WERE LOOKING AT when they signed up.
    //                       Only set if they submitted from a plan page. This is
    //                       the buying signal — it's the plan that was good
    //                       enough to make them hand over an email.
    //   plan-<handle>    -> everything in their list at capture time
    BASE_TAGS:   ['newsletter', 'my-list'],
    FROM_PREFIX: 'from-',
    MAX_PLAN_TAGS: 10,

    // Products that should never get a heart (add-ons, not plans).
    EXCLUDE: [/-study-set$/, /^readable-reverse/, /^gift-card/]
  };

  var K_ITEMS  = 'atlas_mylist_v1';
  var K_EMAIL  = 'atlas_mylist_email_v1';
  var K_OPENED = 'atlas_mylist_opened_v1';
  var K_PENDING = 'atlas_mylist_pending_v1';

  // [ATLAS] Hide the Shopify Form the instant this file parses, NOT at
  // DOMContentLoaded — otherwise it flashes in the footer on every page load
  // before the drawer adopts it. Scoped by attribute so no :has() support is
  // needed; .aml-slot re-shows it once it's inside the drawer.
  (function parkFormEarly() {
    var st = document.createElement('style');
    st.id = 'atlas-ml-park';
    st.textContent =
      '[data-forms-id="forms-root-' + CFG.FORM_ID + '"]{display:none!important}' +
      '.aml-slot [data-forms-id="forms-root-' + CFG.FORM_ID + '"]{display:block!important}';
    (document.head || document.documentElement).appendChild(st);
  })();

  // ==========================================================================
  // STORAGE  — localStorage, with an in-memory fallback so the feature still
  // works in Safari private mode / cookies-blocked, where every call throws.
  // ==========================================================================
  var mem = {};
  function get(k) {
    try { var v = localStorage.getItem(k); if (v !== null) return v; } catch (e) {}
    return mem[k] === undefined ? null : mem[k];
  }
  function set(k, v) {
    mem[k] = v;
    try { localStorage.setItem(k, v); } catch (e) {}
  }

  function items() {
    try {
      var a = JSON.parse(get(K_ITEMS) || '[]');
      return Array.isArray(a) ? a.filter(function (i) { return i && i.handle; }) : [];
    } catch (e) { return []; }
  }
  function saveItems(a) { set(K_ITEMS, JSON.stringify(a.slice(0, CFG.MAX_ITEMS))); }
  function saved(handle) {
    return items().some(function (i) { return i.handle === handle; });
  }

  // ==========================================================================
  // HELPERS
  // ==========================================================================
  function handleOf(url) {
    if (!url) return '';
    var m = String(url).split('?')[0].split('#')[0].match(/\/products\/([^\/]+)/);
    return m ? m[1] : '';
  }
  function excluded(handle) {
    return CFG.EXCLUDE.some(function (re) { return re.test(handle); });
  }
  function thumb(src, w) {
    if (!src) return '';
    var base = String(src).split('?')[0];
    if (base.indexOf('//') === 0) base = 'https:' + base;
    // Shopify CDN already-sized filenames (…_1200x1200.jpg) → strip the suffix
    base = base.replace(/_(\d+)x(\d+)?(_crop_[a-z]+)?(\.(?:jpg|jpeg|png|webp|gif))/i, '$4');
    return base + '?width=' + (w || 200);
  }
  // Titles read "Baileys Bay | Multi-Suite Lake House Plan | 2,998 Sq Ft | 5BR"
  // — split so the drawer can lead with the plan name.
  function splitTitle(t) {
    var parts = String(t || '').split('|').map(function (s) { return s.trim(); })
                 .filter(function (s) { return s; });
    return { name: parts.shift() || 'Plan', sub: parts.join(' · ') };
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function priceNumber(txt) {
    var m = String(txt || '').replace(/,/g, '').match(/([\d.]+)/);
    return m ? parseFloat(m[1]) : 0;
  }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.7l-1.45-1.32C5.4 14.86 2 11.79 2 8.05 2 5.02 4.42 2.6 7.45 2.6' +
    'c1.71 0 3.35.8 4.55 2.06 1.2-1.26 2.84-2.06 4.55-2.06C19.58 2.6 22 5.02 22 8.05' +
    'c0 3.74-3.4 6.81-8.55 11.34L12 20.7z"/></svg>';

  // ==========================================================================
  // ANALYTICS — GA4 is already on the page (gtag + dataLayer, both confirmed).
  // ==========================================================================
  function track(name, item, extra) {
    var payload = extra || {};
    if (item) {
      payload.currency = 'USD';
      payload.value = priceNumber(item.price);
      payload.items = [{
        item_id: item.handle,
        item_name: splitTitle(item.title).name,
        item_category: 'House Plan',
        price: priceNumber(item.price),
        quantity: 1
      }];
    }
    try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: 'atlas_' + name }, payload));
      }
    } catch (e) {}
  }

  // ==========================================================================
  // STYLES
  // ==========================================================================
  function injectCSS() {
    if (document.getElementById('atlas-ml-css')) return;
    var s = document.createElement('style');
    s.id = 'atlas-ml-css';
    s.textContent = [
      ':root{--aml-accent:' + CFG.ACCENT + ';--aml-ink:' + CFG.INK + '}',

      /* ---------- shared heart glyph ---------- */
      '.aml-i{display:block;width:19px;height:19px;flex:0 0 auto}',
      '.aml-i path{fill:none;stroke:currentColor;stroke-width:1.9;stroke-linejoin:round;transition:fill .18s ease}',
      '[aria-pressed="true"] .aml-i path{fill:currentColor}',

      /* ---------- card heart (top-LEFT: top-right is the SAVE badge) ---------- */
      '.aml-card{position:absolute;top:10px;left:10px;z-index:4;width:36px;height:36px;',
      'display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;',
      'background:rgba(255,255,255,.92);color:var(--aml-ink);cursor:pointer;-webkit-appearance:none;',
      'box-shadow:0 1px 5px rgba(0,0,0,.20);transition:transform .18s ease,background .18s ease,color .18s ease}',
      '.aml-card:hover{transform:scale(1.09);background:#fff}',
      '.aml-card[aria-pressed="true"]{color:var(--aml-accent)}',
      '.aml-card:focus-visible{outline:2px solid var(--aml-accent);outline-offset:2px}',
      '.aml-pop{animation:aml-pop .34s ease}',
      '@keyframes aml-pop{0%{transform:scale(1)}40%{transform:scale(1.3)}100%{transform:scale(1)}}',

      /* ---------- product page ---------- */
      '.aml-row{display:flex;gap:10px;align-items:stretch}',
      '.aml-row > [data-add-to-cart]{flex:1 1 auto;min-width:0;width:auto}',
      '.aml-pdp{flex:0 0 auto;display:flex;align-items:center;justify-content:center;gap:9px;',
      'min-height:54px;padding:0 18px;border-radius:8px;cursor:pointer;background:transparent;',
      'border:2px solid var(--aml-ink);color:var(--aml-ink);font-family:Archivo,sans-serif;',
      'font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:1.17px;line-height:1;',
      'white-space:nowrap;transition:background .18s ease,color .18s ease,border-color .18s ease}',
      '.aml-pdp:hover{background:var(--aml-ink);color:#fff}',
      '.aml-pdp[aria-pressed="true"]{border-color:var(--aml-accent);color:var(--aml-accent)}',
      '.aml-pdp[aria-pressed="true"]:hover{background:var(--aml-accent);color:#fff}',
      '.aml-pdp:focus-visible{outline:2px solid var(--aml-accent);outline-offset:2px}',
      '.aml-pdp--full{width:100%;margin-top:10px}',
      // Default in the row (tablet range): icon-only square, label hidden.
      '.aml-row .aml-pdp{width:54px;padding:0}',
      '.aml-row .aml-pdp .aml-t{display:none}',
      // Phone: single column, so unstack the row. Both buttons go full width and
      // the heart shows its label.
      //
      // The width:100% on Add to Cart is NOT redundant. The theme's own
      // btn--full already sets it, but the rule above deliberately overrides
      // that with width:auto so the button can flex beside the heart. Once the
      // row stops being a flex container that override is still in force, and a
      // <button> with width:auto shrinks to its text — which is exactly what
      // shipped: full-width heart above a half-width Add to Cart. Same selector
      // as the rule above, so it wins on source order, and only below the
      // breakpoint.
      '@media (max-width:' + (CFG.PDP_STACK_BELOW - 1) + 'px){',
      '.aml-row{display:block}',
      '.aml-row > [data-add-to-cart]{width:100%}',
      '.aml-row .aml-pdp{width:100%;padding:0 18px;margin-top:10px}',
      '.aml-row .aml-pdp .aml-t{display:inline}}',

      /* ---------- header count ---------- */
      // [ATLAS] align-self:center is LOAD-BEARING, not tidying. The header's
      // right-hand flex row leaves align-items at `normal`, i.e. stretch, so
      // this button inflates to the full 105px header height. The badge is
      // absolutely positioned to the button, so at that height it floats ~70px
      // ABOVE the heart, alone near the top of the header. Centring collapses
      // the button back to its 33px content box and the badge lands on the
      // heart. (Seen live Sep 6 — the badge was way off on its own.)
      '.aml-hdr{position:relative;align-self:center;display:inline-flex;',
      'align-items:center;justify-content:center;color:inherit;background:none;',
      'border:0;padding:6px;cursor:pointer;-webkit-appearance:none}',
      '.aml-hdr .aml-i{width:21px;height:21px}',
      '.aml-hdr[aria-pressed="true"]{color:var(--aml-accent)}',
      // The ring matters: a crimson badge on a crimson filled heart merges into
      // one blob without it.
      '.aml-hdr .aml-n{position:absolute;top:-5px;right:-7px;min-width:16px;height:16px;',
      'padding:0 4px;border-radius:9px;background:var(--aml-accent);color:#fff;',
      'box-shadow:0 0 0 2px #fff;font-family:Archivo,sans-serif;',
      'font-size:10px;font-weight:700;line-height:16px;text-align:center}',
      '.aml-hdr .aml-n[hidden]{display:none}',

      /* ---------- drawer ---------- */
      '.aml-veil{position:fixed;inset:0;background:rgba(0,0,0,.42);z-index:99998;opacity:0;',
      'pointer-events:none;transition:opacity .3s ease}',
      '.aml-veil.on{opacity:1;pointer-events:auto}',
      '.aml-dwr{position:fixed;top:0;right:0;height:100%;width:420px;max-width:100%;background:#fff;',
      'z-index:99999;display:flex;flex-direction:column;transform:translateX(101%);',
      'transition:transform .32s cubic-bezier(.4,0,.2,1);box-shadow:-6px 0 28px rgba(0,0,0,.16);',
      'font-family:Barlow,sans-serif;color:var(--aml-ink)}',
      '.aml-dwr.on{transform:none}',
      '.aml-hd{display:flex;align-items:center;justify-content:space-between;gap:12px;',
      'padding:20px 22px;border-bottom:1px solid #e8e8e8;flex:0 0 auto}',
      '.aml-hd h2{margin:0;font-family:Archivo,sans-serif;font-size:14px;font-weight:600;',
      'text-transform:uppercase;letter-spacing:1.6px}',
      '.aml-x{background:none;border:0;padding:6px;margin:-6px;cursor:pointer;color:var(--aml-ink);',
      'font-size:22px;line-height:1;-webkit-appearance:none}',
      '.aml-x:focus-visible{outline:2px solid var(--aml-accent);outline-offset:2px}',
      '.aml-bd{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:6px 0}',
      '.aml-it{display:flex;gap:14px;padding:14px 22px;border-bottom:1px solid #f1f1f1;align-items:flex-start}',
      '.aml-it img{width:78px;height:62px;object-fit:cover;border-radius:5px;flex:0 0 auto;background:#f4f4f4}',
      '.aml-it .aml-m{flex:1 1 auto;min-width:0}',
      '.aml-it a{color:var(--aml-ink);text-decoration:none;font-weight:600;font-size:15px;line-height:1.3;display:block}',
      '.aml-it a:hover{text-decoration:underline}',
      '.aml-it .aml-s{margin:3px 0 0;font-size:12.5px;line-height:1.4;color:#6b6b6b}',
      '.aml-it .aml-p{margin:6px 0 0;font-family:Archivo,sans-serif;font-size:13px;font-weight:600;letter-spacing:.4px}',
      '.aml-rm{background:none;border:0;padding:4px;cursor:pointer;color:#9a9a9a;font-size:17px;',
      'line-height:1;flex:0 0 auto;-webkit-appearance:none}',
      '.aml-rm:hover{color:var(--aml-accent)}',
      '.aml-rm:focus-visible{outline:2px solid var(--aml-accent);outline-offset:2px}',
      '.aml-none{padding:52px 30px;text-align:center;color:#6b6b6b;font-size:15px;line-height:1.6}',
      '.aml-none svg{width:38px;height:38px;margin:0 auto 14px;color:#d6d6d6;display:block}',
      '.aml-none a{color:var(--aml-ink);font-weight:600}',

      /* ---------- drawer footer / email ---------- */
      '.aml-ft{flex:0 0 auto;border-top:1px solid #e8e8e8;padding:18px 22px;background:#fafafa}',
      '.aml-ft p{margin:0 0 12px;font-size:13.5px;line-height:1.55;color:#4a4a4a}',
      '.aml-ft strong{color:var(--aml-ink)}',
      '.aml-f{display:flex;gap:8px}',
      '.aml-f input[type=email]{flex:1 1 auto;min-width:0;height:46px;padding:0 13px;border:1px solid #cfcfcf;',
      'border-radius:6px;font-family:Barlow,sans-serif;font-size:15px;color:var(--aml-ink);background:#fff}',
      '.aml-f input[type=email]:focus{outline:none;border-color:var(--aml-ink);box-shadow:0 0 0 2px rgba(0,0,0,.06)}',
      '.aml-f button{flex:0 0 auto;height:46px;padding:0 20px;border:0;border-radius:6px;cursor:pointer;',
      'background:var(--aml-accent);color:#fff;font-family:Archivo,sans-serif;font-size:12px;font-weight:600;',
      'text-transform:uppercase;letter-spacing:1.1px;-webkit-appearance:none}',
      '.aml-f button:disabled{opacity:.55;cursor:default}',
      '.aml-hp{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important}',
      /* the adopted Shopify Form fills the slot and nothing more */
      '.aml-slot{width:100%}',
      '.aml-slot .shopify-app-block,.aml-slot [data-forms-id]{width:100%!important;max-width:100%!important;box-sizing:border-box!important}',
      '.aml-slot shopify-forms-embed{display:block!important;width:100%!important}',
      '.aml-msg{margin:10px 0 0;font-size:13px;line-height:1.5}',
      '.aml-msg.err{color:var(--aml-accent)}',
      '.aml-msg.ok{color:#2f7d43}',
      '.aml-fine{margin:16px 0 0;font-size:11.5px;line-height:1.5;color:#8a8a8a}',
      '.aml-cta{display:block;width:100%;margin-top:12px;padding:14px;border:0;border-radius:8px;',
      'background:var(--aml-ink);color:#fff;font-family:Archivo,sans-serif;font-size:12.5px;font-weight:600;',
      'text-transform:uppercase;letter-spacing:1.2px;text-align:center;text-decoration:none;cursor:pointer}',

      /* ---------- toast ---------- */
      '.aml-tst{position:fixed;right:20px;z-index:99997;display:flex;align-items:center;gap:14px;',
      'max-width:calc(100vw - 40px);padding:13px 18px;border-radius:9px;background:var(--aml-ink);color:#fff;',
      'font-family:Barlow,sans-serif;font-size:14px;box-shadow:0 6px 22px rgba(0,0,0,.28);',
      'opacity:0;transform:translateY(14px);pointer-events:none;transition:opacity .25s ease,transform .25s ease}',
      '.aml-tst.on{opacity:1;transform:none;pointer-events:auto}',
      '.aml-tst button{background:none;border:0;padding:0;color:#fff;font-family:Archivo,sans-serif;',
      'font-size:11.5px;font-weight:600;text-transform:uppercase;letter-spacing:1.1px;cursor:pointer;',
      'text-decoration:underline;text-underline-offset:3px;white-space:nowrap;-webkit-appearance:none}',

      '@media (prefers-reduced-motion:reduce){.aml-card,.aml-pop,.aml-dwr,.aml-veil,.aml-tst',
      '{transition:none!important;animation:none!important}}'
    ].join('');
    document.head.appendChild(s);
  }

  // ==========================================================================
  // TOAST — measured so it never lands under the sticky Buy bar on plan pages
  // ==========================================================================
  var toastEl, toastTimer;
  function bottomObstruction() {
    var vh = window.innerHeight, worst = 0;
    var nodes = document.querySelectorAll('div,section,form,footer,nav,aside');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.aml-dwr, .aml-tst')) continue;
      var pos = getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      if (r.height && r.height < 220 && r.bottom > vh - 4 && r.bottom < vh + 60 && r.width > 200) {
        if (r.height > worst) worst = r.height;
      }
    }
    return worst;
  }
  function toast(msg, actionLabel, action) {
    injectCSS();
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'aml-tst';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span></span>';
    toastEl.firstChild.textContent = msg;
    if (actionLabel) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = actionLabel;
      b.addEventListener('click', function () { hideToast(); action(); });
      toastEl.appendChild(b);
    }
    toastEl.style.bottom = (bottomObstruction() + 20) + 'px';
    requestAnimationFrame(function () { toastEl.classList.add('on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4200);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('on'); }

  // ==========================================================================
  // CORE — add / remove
  // ==========================================================================
  function add(item) {
    if (!item || !item.handle) return;
    var all = items();
    if (all.some(function (i) { return i.handle === item.handle; })) return;
    item.ts = Date.now();
    all.unshift(item);
    saveItems(all);
    sync();
    refreshDrawer();
    syncFormFields();
    track('add_to_wishlist', item);

    if (CFG.OPEN_ON_FIRST_SAVE && !get(K_OPENED)) {
      set(K_OPENED, '1');
      setTimeout(function () { openDrawer('auto_first_save'); }, 340);
    } else {
      toast('Saved to ' + CFG.NAME, 'View ' + CFG.NAME, function () { openDrawer('toast'); });
    }
  }
  function remove(handle) {
    var all = items(), gone = null;
    all = all.filter(function (i) {
      if (i.handle === handle) { gone = i; return false; }
      return true;
    });
    saveItems(all);
    sync();
    refreshDrawer();
    if (gone) track('remove_from_wishlist', gone);
  }
  function toggle(item, btn) {
    if (saved(item.handle)) {
      remove(item.handle);
    } else {
      add(item);
      if (btn) {
        btn.classList.remove('aml-pop');
        void btn.offsetWidth;
        btn.classList.add('aml-pop');
      }
    }
  }

  // ==========================================================================
  // PRODUCT CARDS
  // ==========================================================================
  function cardItem(card) {
    var link = card.querySelector('a[data-grid-link]') || card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var handle = handleOf(link.getAttribute('href'));
    if (!handle || excluded(handle)) return null;
    var img = card.querySelector('.product-grid-item__images img') || card.querySelector('img');
    var t = card.querySelector('.product__grid__title');
    var p = card.querySelector('.product__grid__price .price') || card.querySelector('.price');
    return {
      handle: handle,
      id: card.getAttribute('data-item-id') || '',
      title: t ? t.textContent.replace(/\s+/g, ' ').trim() : handle,
      price: p ? p.textContent.replace(/\s+/g, ' ').trim() : '',
      image: img ? thumb(img.currentSrc || img.getAttribute('src'), 220) : ''
    };
  }

  function decorateCards() {
    var cards = document.querySelectorAll('product-grid-item:not([data-aml])');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.setAttribute('data-aml', '1'); // bind once
        var item = cardItem(card);
        if (!item) return;
        var host = card.querySelector('.product-grid-item__container') || card;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'aml-card';
        btn.setAttribute('data-aml-handle', item.handle);
        btn.setAttribute('data-aml-title', item.title);
        btn.innerHTML = HEART.replace('<svg', '<svg class="aml-i"');
        paint(btn, item);
        btn.addEventListener('click', function (e) {
          // The whole card is a link — don't navigate when the heart is hit.
          e.preventDefault(); e.stopPropagation();
          toggle(cardItem(card) || item, btn);
        });
        host.appendChild(btn);
      })(cards[i]);
    }
  }

  function paint(btn, item) {
    var on = saved(item.handle || btn.getAttribute('data-aml-handle'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var name = splitTitle(item && item.title ? item.title : '').name;
    btn.setAttribute('aria-label',
      (on ? 'Remove ' : 'Save ') + (name || 'this plan') +
      (on ? ' from ' : ' to ') + CFG.NAME);
    btn.setAttribute('title', on ? 'Saved to ' + CFG.NAME : 'Save to ' + CFG.NAME);
    var t = btn.querySelector('.aml-t');
    if (t) t.textContent = on ? CFG.PDP_SAVED : CFG.PDP_LABEL;
  }

  // ==========================================================================
  // PRODUCT PAGE
  // ==========================================================================
  function pdpItem() {
    var handle = handleOf(location.pathname);
    if (!handle || excluded(handle)) return null;

    var ld = null;
    var tags = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < tags.length; i++) {
      try {
        var j = JSON.parse(tags[i].textContent);
        if (j && j['@type'] === 'Product') { ld = j; break; }
      } catch (e) {}
    }

    var h1 = document.querySelector('h1.product__title') || document.querySelector('h1');
    var priceEl = document.querySelector('.product__price');
    var og = document.querySelector('meta[property="og:image"]');
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
                window.ShopifyAnalytics.meta.product) || null;

    var title = (ld && ld.name) ||
                (h1 && h1.textContent.trim()) ||
                (document.title.split('|')[0].trim());

    var image = '';
    if (ld && ld.image) image = Array.isArray(ld.image) ? ld.image[0] : ld.image;
    if (!image && og) image = og.getAttribute('content');

    return {
      handle: handle,
      id: meta ? String(meta.id) : '',
      title: title,
      price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
      image: thumb(image, 220)
    };
  }

  function decoratePdp() {
    if (document.querySelector('.aml-pdp')) return;
    var wrap = document.querySelector('.product__submit__buttons');
    if (!wrap) return;
    var item = pdpItem();
    if (!item) return;

    var inline = CFG.PDP_LAYOUT === 'inline';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aml-pdp' + (inline ? '' : ' aml-pdp--full');
    btn.setAttribute('data-aml-handle', item.handle);
    btn.setAttribute('data-aml-title', item.title);
    // The label is always in the DOM (screen readers and the stacked layout
    // both need it); CSS hides it in the desktop icon-only row.
    btn.innerHTML = HEART.replace('<svg', '<svg class="aml-i"') +
      '<span class="aml-t"></span>';
    paint(btn, item);
    btn.addEventListener('click', function () { toggle(pdpItem() || item, btn); });

    if (inline) {
      // [ATLAS] Wrap the ADD TO CART BUTTON, not .product__submit__buttons.
      // On plans that offer a study set, that container also holds the "OR",
      // the GET STUDY SET button and its note — wrapping it made the heart
      // stretch to the height of the whole stack (seen live on a Garage/ADU
      // page, ~300px tall). The row must contain exactly two things:
      // Add to Cart, and the heart.
      var atc = wrap.querySelector('[data-add-to-cart]');
      if (atc) {
        var row = document.createElement('div');
        row.className = 'aml-row';
        atc.parentNode.insertBefore(row, atc);
        row.appendChild(atc);
        row.appendChild(btn);
      } else {
        btn.className = 'aml-pdp aml-pdp--full';
        wrap.parentNode.insertBefore(btn, wrap.nextSibling);
      }
    } else {
      wrap.parentNode.insertBefore(btn, wrap.nextSibling);
    }
  }

  // ==========================================================================
  // HEADER COUNT
  // ==========================================================================
  function decorateHeader() {
    var slots = document.querySelectorAll('.header__mobile__right, .header__desktop__buttons');
    for (var i = 0; i < slots.length; i++) {
      (function (slot) {
        if (slot.querySelector('.aml-hdr')) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'aml-hdr';
        btn.innerHTML = HEART.replace('<svg', '<svg class="aml-i"') +
                        '<span class="aml-n" hidden>0</span>';
        btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer('header'); });
        var cart = slot.querySelector('a[href="/cart"]');
        var anchor = cart ? (cart.closest('.header__desktop__button') || cart) : null;
        if (anchor && anchor.parentNode === slot) slot.insertBefore(btn, anchor);
        else slot.insertBefore(btn, slot.firstChild);
      })(slots[i]);
    }
  }

  // ==========================================================================
  // DRAWER
  // ==========================================================================
  var veil, drawer, lastFocus;

  function buildDrawer() {
    if (drawer) return;
    veil = document.createElement('div');
    veil.className = 'aml-veil';
    veil.addEventListener('click', closeDrawer);

    drawer = document.createElement('aside');
    drawer.className = 'aml-dwr';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', CFG.NAME);
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="aml-hd"><h2></h2>' +
      '<button type="button" class="aml-x" aria-label="Close ' + esc(CFG.NAME) + '">&times;</button></div>' +
      '<div class="aml-bd"></div><div class="aml-ft"></div>';
    drawer.querySelector('.aml-x').addEventListener('click', closeDrawer);

    document.body.appendChild(veil);
    document.body.appendChild(drawer);

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('on')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('button,a[href],input,[tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function renderDrawer() {
    if (!drawer) return;
    var list = items();
    drawer.querySelector('.aml-hd h2').textContent =
      CFG.NAME + (list.length ? ' (' + list.length + ')' : '');

    var body = drawer.querySelector('.aml-bd');
    if (!list.length) {
      body.innerHTML =
        '<div class="aml-none">' + HEART.replace('<svg', '<svg class="aml-i"') +
        '<p>Nothing saved yet.</p><p>Tap the heart on any plan to keep it here ' +
        'while you compare.</p><p style="margin-top:18px">' +
        '<a href="/collections/house-plans">Browse all house plans &rarr;</a></p></div>';
    } else {
      body.innerHTML = list.map(function (i) {
        var t = splitTitle(i.title);
        return '<div class="aml-it" data-h="' + esc(i.handle) + '">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') +
          '<div class="aml-m">' +
            '<a href="/products/' + esc(i.handle) + '">' + esc(t.name) + '</a>' +
            (t.sub ? '<p class="aml-s">' + esc(t.sub) + '</p>' : '') +
            (i.price ? '<p class="aml-p">' + esc(i.price) + '</p>' : '') +
          '</div>' +
          '<button type="button" class="aml-rm" aria-label="Remove ' + esc(t.name) +
            ' from ' + esc(CFG.NAME) + '">&times;</button>' +
        '</div>';
      }).join('');
      body.querySelectorAll('.aml-rm').forEach(function (b) {
        b.addEventListener('click', function () {
          remove(b.parentNode.getAttribute('data-h'));
        });
      });
    }
    renderFooter(list);
  }

  // ==========================================================================
  // THE SHOPIFY FORM
  // --------------------------------------------------------------------------
  // Why a Shopify Form and not our own: Shopify puts an invisible CAPTCHA on
  // customer forms. A fetch() POST to /contact returns 400, and even a
  // programmatic submit of a real Liquid {% form 'customer' %} lands on a page
  // titled "Missing CAPTCHA token". Both were built and proven dead Sep 6 2026.
  // Shopify Forms carries the token itself and submits over AJAX, so the page
  // never reloads. We MOVE its rendered node into the drawer — verified live
  // that the custom element survives relocation with its shadow DOM, fields and
  // submit button intact.
  // ==========================================================================
  function formRoot() {
    return document.querySelector('[data-forms-id="forms-root-' + CFG.FORM_ID + '"]');
  }
  function formBlock() {
    var r = formRoot();
    return r ? (r.closest('.shopify-app-block') || r.parentElement) : null;
  }
  function formEmbed() {
    var b = formBlock();
    return b ? b.querySelector('shopify-forms-embed') : null;
  }
  // Fields sit inside a shadow root — getElementById on document finds nothing.
  function formField(id) {
    var e = formEmbed();
    return (e && e.shadowRoot) ? e.shadowRoot.getElementById(id) : null;
  }
  function formElement() {
    var e = formEmbed();
    return (e && e.shadowRoot) ? e.shadowRoot.querySelector('form') : null;
  }

  // [ATLAS] Setting el.value directly is SILENTLY IGNORED by the form's own
  // framework — it never sees a value it didn't watch being set. Use the native
  // setter and fire the events, exactly as modification-request-autofill.liquid
  // does. That snippet is the reference implementation for all of this.
  function setNative(el, value) {
    if (!el) return false;
    var proto = el.tagName === 'TEXTAREA'
      ? window.HTMLTextAreaElement.prototype
      : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
    setter.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // [ATLAS] Shopify Forms renders inside a shadow root, so the page's CSS cannot
  // reach it — out of the box it drops a centred "My List / Complete the form to
  // sign up" heading and its own input and button styling into the drawer, which
  // looks nothing like the rest of it. Inject a stylesheet INTO the shadow root
  // instead. Class names are hashed (._formHeader_jnbzb_24) and the hash will
  // change when Shopify updates the app, so match on the stable prefix only.
  function styleShadow() {
    var e = formEmbed();
    var sr = e && e.shadowRoot;
    if (!sr || sr.getElementById('aml-shadow-css')) return;
    var st = document.createElement('style');
    st.id = 'aml-shadow-css';
    st.textContent = [
      '*{box-sizing:border-box!important}',
      // the drawer already says all this
      '[class*="_formHeader_"]{display:none!important}',
      '[class*="_imageLoading_"]{display:none!important}',
      // strip the app's own chrome so it sits flush
      '[class*="_appEmbedRoot_"],[class*="_appEmbed_"],[class*="_container_"],',
      '[class*="_inline_"],[class*="_formContainer_"],[class*="_gridItem_"],',
      '[class*="_formFieldset_"]{padding:0!important;margin:0!important;background:none!important;',
      'text-align:left!important;min-height:0!important;width:100%!important;max-width:100%!important}',
      // email + submit on one line, like everything else in the drawer
      '[class*="_formFieldset_"]{display:flex!important;flex-direction:row!important;',
      'align-items:stretch!important;gap:8px!important}',
      '[class*="_formFieldContainer_"]{flex:1 1 auto!important;min-width:0!important;margin:0!important}',
      'input[class*="_formInputField_"]{width:100%!important;',
      'border:1px solid #cfcfcf!important;border-radius:6px!important;background:#fff!important;box-shadow:none!important;',
      'font-family:Barlow,sans-serif!important;font-size:15px!important;color:' + CFG.INK + '!important}',
      'input[class*="_formInputField_"]:focus{border-color:' + CFG.INK + '!important;outline:none!important;',
      'box-shadow:0 0 0 2px rgba(0,0,0,.06)!important}',
      'label[class*="_formInputFieldLabel_"]{font-family:Barlow,sans-serif!important;',
      'font-size:15px!important;color:#8a8a8a!important}',
      'button[type=submit]{flex:0 0 auto!important;width:auto!important;height:auto!important;',
      'padding:0 20px!important;margin:0!important;border:0!important;border-radius:6px!important;',
      'white-space:nowrap!important;cursor:pointer!important;',
      // the label is a ::after, i.e. an inline box — without flex centring it
      // sits on the text baseline at the top of the button
      'display:flex!important;align-items:center!important;justify-content:center!important;',
      'line-height:1!important;',
      'background:' + CFG.ACCENT + '!important;color:#fff!important;',
      'font-family:Archivo,sans-serif!important;font-size:12px!important;font-weight:600!important;',
      'text-transform:uppercase!important;letter-spacing:1.1px!important}',
      // relabel without touching the app's own DOM
      'button[type=submit]{font-size:0!important}',
      'button[type=submit] *{font-size:0!important}',
      'button[type=submit]::after{content:"' + CFG.SEND_LABEL + '";',
      'font-family:Archivo,sans-serif;font-size:12px;font-weight:600;',
      'letter-spacing:1.1px;text-transform:uppercase;color:#fff}'
    ].join('');
    sr.appendChild(st);
  }

  function hideFormField(id) {
    var f = formField(id);
    if (!f || f.getAttribute('data-aml-hidden')) return;
    f.setAttribute('data-aml-hidden', '1');
    // Hide the field's own wrapper so its label goes too — but never a wrapper
    // that also holds another field.
    var wrap = f.parentElement;
    if (wrap && wrap.querySelectorAll('input, textarea, select').length === 1) {
      wrap.style.display = 'none';
      return;
    }
    f.style.display = 'none';
    var e = formEmbed();
    if (e && e.shadowRoot) {
      var safe = (window.CSS && CSS.escape) ? CSS.escape(id) : id;
      var lbl = e.shadowRoot.querySelector('label[for="' + safe + '"]');
      if (lbl) lbl.style.display = 'none';
    }
  }

  // [ATLAS] Shopify Forms positions its label with an INLINE style (top: 22px),
  // sized for its own taller default input. A stylesheet rule — even !important
  // — does not reliably win against it, so we set the property on the element
  // with priority instead.
  //
  // BUT the label FLOATS. An earlier version of this function pinned it
  // unconditionally and the pin beat the float, so the word "Email" sat on top
  // of whatever the customer typed. The pin is therefore conditional: it holds
  // only while the field is empty and unfocused (the resting state, where the
  // label acts as a placeholder). The moment the field is focused or has a
  // value we clear our three properties and hand positioning back to Forms so
  // its own float-up animation runs untouched.
  function labelInput(lbl) {
    var e = formEmbed();
    if (!e || !e.shadowRoot) return null;
    var f = lbl.getAttribute('for');
    return f ? e.shadowRoot.getElementById(f) : null;
  }

  function centreFormLabel() {
    var e = formEmbed();
    if (!e || !e.shadowRoot) return;
    var root = e.shadowRoot;
    var labels = root.querySelectorAll('label[class*="_formInputFieldLabel_"]');
    for (var i = 0; i < labels.length; i++) {
      var lbl = labels[i];
      var inp = labelInput(lbl);
      var floated = !!inp && (inp.value !== '' || root.activeElement === inp);
      if (floated) {
        // Hand it back. removeProperty, not setProperty('') — the latter can
        // leave an empty declaration that still shadows the stylesheet.
        lbl.style.removeProperty('top');
        lbl.style.removeProperty('transform');
        lbl.style.removeProperty('line-height');
      } else {
        lbl.style.setProperty('top', '50%', 'important');
        lbl.style.setProperty('transform', 'translateY(-50%)', 'important');
        lbl.style.setProperty('line-height', '1', 'important');
      }
    }
  }

  // syncFormFields only runs on drawer/DOM changes, which is far too coarse for
  // typing. Bind directly to the field so the pin releases on the first
  // keystroke. Guarded by a flag on the shadow root so re-renders do not stack
  // duplicate listeners.
  function bindFormLabelWatch() {
    var e = formEmbed();
    if (!e || !e.shadowRoot) return;
    var root = e.shadowRoot;
    if (root.__amlLabelBound) return;
    var form = root.querySelector('form');
    if (!form) return;
    root.__amlLabelBound = true;
    var relay = function () { centreFormLabel(); };
    // focusin/focusout, not focus/blur — those do not bubble.
    form.addEventListener('input', relay, true);
    form.addEventListener('focusin', relay, true);
    form.addEventListener('focusout', relay, true);
    form.addEventListener('change', relay, true);
  }

  // The three values the drawer contributes. Kept continuously in sync rather
  // than raced onto the form at submit time, so whenever the customer hits
  // Submit they are already filled.
  function syncFormFields() {
    if (!formEmbed() || !formField('custom#list_url')) return false;
    styleShadow();
    centreFormLabel();
    bindFormLabelWatch();

    var list = items();
    var handles = list.map(function (i) { return i.handle; });
    var from = handleOf(location.pathname);
    var fromItem = null;
    if (from) {
      fromItem = list.filter(function (i) { return i.handle === from; })[0] || null;
    }
    var planName = fromItem ? splitTitle(fromItem.title).name
                            : (list.length ? splitTitle(list[0].title).name : '');

    setNative(formField('custom#plan_name'), planName);
    setNative(formField('custom#saved_plans'), handles.join(','));
    setNative(formField('custom#list_url'),
      handles.length ? (location.origin + '/?list=' + handles.join(',')) : location.origin);

    hideFormField('custom#plan_name');
    hideFormField('custom#saved_plans');
    hideFormField('custom#list_url');
    return true;
  }

  function parkForm() {
    // Put the form back in its own home before anything replaces the footer's
    // innerHTML — otherwise we destroy the only node that can submit.
    var b = formBlock();
    var home = document.getElementById('aml-form-home');
    if (b && home && b.parentNode !== home) home.appendChild(b);
  }

  function adoptForm(slot) {
    var b = formBlock();
    if (!b) return false;
    if (!document.getElementById('aml-form-home')) {
      var home = document.createElement('div');
      home.id = 'aml-form-home';
      home.style.display = 'none';
      b.parentNode.insertBefore(home, b);
    }
    slot.appendChild(b);

    // Forms renders asynchronously, so poll briefly for the fields rather than
    // assuming they exist — same ~10s ceiling the modification-request snippet uses.
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (syncFormFields() || tries > 40) {
        clearInterval(poll);
        wireFormSubmit();
      }
    }, 250);
    return true;
  }

  function wireFormSubmit() {
    var f = formElement();
    if (!f || f.getAttribute('data-aml-wired')) return;
    f.setAttribute('data-aml-wired', '1');

    // No preventDefault. Shopify Forms owns the submit and the CAPTCHA token —
    // we only ride along to record the lead and watch for its success state.
    f.addEventListener('submit', function () {
      syncFormFields();
      var box = formField('email');
      var value = (box && box.value || '').trim();
      var list = items();
      var from = handleOf(location.pathname);

      if (value) set(K_PENDING, value);

      track('generate_lead', null, {
        method: 'my_list_email_capture',
        saved_plans: list.length,
        from_plan: from || '(not a plan page)',
        plans: list.slice(0, 10).map(function (i) { return i.handle; }).join(',')
      });

      watchForSuccess();
    });
  }

  // Forms swaps its own success state in place. Watch for the email field going
  // away, then flip the drawer footer to the confirmed view.
  function watchForSuccess() {
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (!formField('email')) {
        clearInterval(poll);
        var pending = get(K_PENDING);
        if (pending) {
          set(K_EMAIL, pending);
          set(K_PENDING, '');
          try { localStorage.removeItem(K_PENDING); } catch (e) {}
        }
        sync();
        refreshDrawer();
      } else if (tries > 40) {
        clearInterval(poll);
      }
    }, 250);
  }

  function renderFooter(list) {
    var ft = drawer.querySelector('.aml-ft');
    var email = get(K_EMAIL);
    var mode = !list.length ? 'empty' : (email ? 'done' : 'ask');

    // [ATLAS] Rebuilding this footer destroys the email input, taking any
    // half-typed address and the caret with it. Only rebuild when the MODE
    // actually changes — and park the Shopify form first, always.
    if (ft.getAttribute('data-aml-mode') === mode &&
        (mode !== 'done' || ft.getAttribute('data-aml-email') === email)) {
      if (mode === 'ask') syncFormFields();
      return;
    }

    parkForm();
    ft.setAttribute('data-aml-mode', mode);
    if (mode === 'done') ft.setAttribute('data-aml-email', email);

    if (mode === 'empty') { ft.innerHTML = ''; ft.style.display = 'none'; return; }
    ft.style.display = '';

    if (mode === 'done') {
      ft.innerHTML =
        '<p>&#10003; <strong>' + esc(email) + '</strong> is on the list. ' +
        esc(CFG.ASK_DONE) + '</p>' +
        '<a class="aml-cta" href="/collections/house-plans">Keep browsing plans</a>';
      return;
    }

    ft.innerHTML =
      '<p><strong>' + esc(CFG.ASK_HEAD) + '</strong> ' + esc(CFG.ASK_BODY) + '</p>' +
      '<div class="aml-slot"></div>' +
      '<p class="aml-fine">' + esc(CFG.ASK_FINE) + '</p>';

    if (!adoptForm(ft.querySelector('.aml-slot'))) {
      ft.querySelector('.aml-slot').innerHTML =
        '<p class="aml-msg err">Email sign-up isn’t available right now.</p>';
      console.error('[ATLAS] My List: Shopify Form ' + CFG.FORM_ID + ' is not on this ' +
        'page. It must stay in the Footer section group so it renders sitewide. ' +
        'Without it there is no way to create a customer — Shopify CAPTCHA blocks ' +
        'every JS-driven submit.');
    }
  }

  // [ATLAS] `trigger` says WHO opened the drawer, and it matters. The drawer
  // auto-opens on someone's first save, so without this `view_wishlist` counts
  // opens THIS CODE caused, not opens the customer chose — which is why views
  // outnumbered saves in GA4 on day one. Filter to trigger != 'auto_first_save'
  // for the number that actually means "they came back to their list".
  function openDrawer(trigger) {
    injectCSS();
    buildDrawer();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    renderDrawer();
    hideToast();
    requestAnimationFrame(function () {
      veil.classList.add('on');
      drawer.classList.add('on');
      var f = drawer.querySelector('.aml-f input[type=email]') || drawer.querySelector('.aml-x');
      if (f) f.focus({ preventScroll: true });
    });
    document.documentElement.style.overflow = 'hidden';
    syncFormFields();
    track('view_wishlist', null, {
      item_count: items().length,
      open_trigger: trigger || 'unknown'
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    veil.classList.remove('on');
    drawer.classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!drawer.classList.contains('on')) drawer.hidden = true; }, 340);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // ==========================================================================
  // SYNC — repaint every heart + the header count
  // ==========================================================================
  function sync() {
    var n = items().length;
    document.querySelectorAll('.aml-hdr').forEach(function (b) {
      var badge = b.querySelector('.aml-n');
      badge.textContent = n;
      badge.hidden = n === 0;
      b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
      b.setAttribute('aria-label', n ? CFG.NAME + ', ' + n + ' plan' + (n === 1 ? '' : 's') + ' saved'
                                    : 'Open ' + CFG.NAME);
      b.setAttribute('title', CFG.NAME);
    });
    document.querySelectorAll('[data-aml-handle]').forEach(function (b) {
      paint(b, { handle: b.getAttribute('data-aml-handle'), title: b.getAttribute('data-aml-title') || '' });
    });
  }

  // [ATLAS] 🔴 sync() DELIBERATELY does not touch the drawer. It used to end with
  // `if (drawer.classList.contains('on')) renderDrawer()`, and that shipped a bug
  // that made the email field impossible to use:
  //     any page mutation -> MutationObserver -> schedule() -> sync()
  //     -> renderDrawer() -> renderFooter() -> ft.innerHTML = ...
  //     -> the <input> node is destroyed and rebuilt
  // A live page mutates constantly (lazy images, the sticky ATC bar, Alpine, the
  // announcement bar), so the box was wiped several times a second and focus fell
  // back to <body>. You could not type a single character.
  // Re-render the drawer ONLY when the list actually changed — that's this:
  function refreshDrawer() {
    if (drawer && drawer.classList.contains('on')) renderDrawer();
  }

  // ==========================================================================
  // ?list=handle,handle — lets an email link rebuild someone's list on a new
  // device. Fetches the real title/price/image from Shopify for each handle.
  // ==========================================================================
  function hydrateFromUrl() {
    var m = location.search.match(/[?&]list=([^&]+)/);
    if (!m) return;
    var handles = decodeURIComponent(m[1]).split(',')
      .map(function (h) { return h.trim(); })
      .filter(function (h) { return h && !excluded(h) && !saved(h); })
      .slice(0, 20);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var all = items();
      results.forEach(function (p) {
        if (!p) return;
        all.push({
          handle: p.handle,
          id: String(p.id),
          title: p.title,
          price: '$' + (p.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 }),
          image: thumb(p.featured_image, 220),
          ts: Date.now()
        });
      });
      saveItems(all);
      sync();
      if (items().length) openDrawer('email_link');
    });
  }

  // ==========================================================================
  // BOOT
  // ==========================================================================
  function boot() {
    injectCSS();
    decorateHeader();
    decorateCards();
    decoratePdp();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Collection filters and quick-view swap the grid in via the Section
  // Rendering API, so new cards appear after first paint — watch for them.
  //
  // [ATLAS] Two guards here, both load-bearing:
  //   1. Mutations INSIDE our own drawer/toast are ignored. Without this,
  //      re-rendering the drawer triggers the observer, which calls sync(),
  //      which re-renders the drawer — an infinite loop that pins the CPU.
  //   2. Work is debounced into one animation frame, so a filter swap that
  //      replaces 36 cards costs one pass, not 36.
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      decorateHeader();
      decorateCards();
      decoratePdp();
      sync();
    });
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType === 1 && t.closest && t.closest('.aml-dwr,.aml-tst')) continue;
      schedule();
      return;
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  // A second tab saving a plan should update this one.
  window.addEventListener('storage', function (e) {
    if (e.key === K_ITEMS || e.key === K_EMAIL) { sync(); refreshDrawer(); }
  });

  // #my-list opens the drawer from any link, anywhere on the site.
  function hashCheck() {
    if (location.hash === '#my-list') openDrawer('hash_link');
  }
  window.addEventListener('hashchange', hashCheck);
  window.addEventListener('load', function () { hashCheck(); hydrateFromUrl(); });

  // Escape hatch for the console: window.AtlasMyList.reset()
  window.AtlasMyList = {
    open: function (t) { openDrawer(t || 'console'); },
    items: items,
    reset: function () {
      set(K_ITEMS, '[]'); set(K_EMAIL, ''); set(K_OPENED, ''); set(K_PENDING, '');
      try { localStorage.removeItem(K_ITEMS); localStorage.removeItem(K_EMAIL);
            localStorage.removeItem(K_OPENED); } catch (e) {}
      sync();
      if (drawer && drawer.classList.contains('on')) renderDrawer();
    }
  };
})();